import { action } from "satcheljs";
import type { TableView } from "owa-mail-list-store";

export interface ON_INITIAL_TABLE_LOAD_COMPLETEActionMessage {
    tableView: TableView;
}
export const onInitialTableLoadComplete: (tableView: TableView) => ON_INITIAL_TABLE_LOAD_COMPLETEActionMessage = action("ON_INITIAL_TABLE_LOAD_COMPLETE", (tableView: TableView): ON_INITIAL_TABLE_LOAD_COMPLETEActionMessage => ({
    tableView,
}));
